module.exports = __webpack_public_path__ + "img/193-ad11fe.png";